var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.121,
    height: 23.109,
    viewBox: "0 0 23.121 23.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-66.899 -846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(66.899 846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6342",
    "data-name": "Path 6342",
    d: "M-1028.837,436.629c0-.428-.012-.779,0-1.13a.886.886,0,0,1,.717-.886.866.866,0,0,1,1.009.52,1.109,1.109,0,0,1,.07.4c.006.962,0,1.924.005,2.885a.863.863,0,0,1-.515.855.875.875,0,0,1-.963-.123q-1.611-1.227-3.223-2.453a3.6,3.6,0,0,0-4.647,0c-1.945,1.487-3.889,2.976-5.844,4.451a3.777,3.777,0,0,0-1.586,3.185q0,3.572,0,7.145a3.657,3.657,0,0,0,3.881,3.866h11.816a3.653,3.653,0,0,0,3.805-3.8c0-2.37-.007-4.74,0-7.11a3.83,3.83,0,0,0-1.413-3.17.864.864,0,0,1-.162-1.276.88.88,0,0,1,1.309-.111,5.207,5.207,0,0,1,2.043,4.1q.062,3.966,0,7.934a5.358,5.358,0,0,1-5.247,5.221q-6.285.046-12.572,0a5.366,5.366,0,0,1-5.252-5.253q-.044-3.932,0-7.866a5.057,5.057,0,0,1,1.986-4.054q3.155-2.484,6.383-4.876a5.362,5.362,0,0,1,6.4.049C-1030.178,435.6-1029.544,436.093-1028.837,436.629Z",
    transform: "translate(1045.618 -434.04)",
    fill: "#cc0e2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6343",
    "data-name": "Path 6343",
    d: "M-989.6,522.679a1.1,1.1,0,0,1-1.128,1.127,1.139,1.139,0,0,1-1.124-1.147,1.139,1.139,0,0,1,1.127-1.11A1.1,1.1,0,0,1-989.6,522.679Z",
    transform: "translate(1000.474 -507.52)",
    fill: "#cc0e2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6344",
    "data-name": "Path 6344",
    d: "M-969.235,522.667a1.1,1.1,0,0,1,1.135-1.119,1.139,1.139,0,0,1,1.116,1.12,1.141,1.141,0,0,1-1.135,1.136A1.1,1.1,0,0,1-969.235,522.667Z",
    transform: "translate(981.481 -507.518)",
    fill: "#cc0e2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6345",
    "data-name": "Path 6345",
    d: "M-990.724,501.35a1.115,1.115,0,0,1-1.136-1.123,1.132,1.132,0,0,1,1.152-1.109,1.091,1.091,0,0,1,1.1,1.109A1.079,1.079,0,0,1-990.724,501.35Z",
    transform: "translate(1000.478 -488.685)",
    fill: "#cc0e2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M-968.111,501.367a1.079,1.079,0,0,1-1.122-1.118,1.076,1.076,0,0,1,1.129-1.11,1.111,1.111,0,0,1,1.122,1.1A1.114,1.114,0,0,1-968.111,501.367Z",
    transform: "translate(981.479 -488.702)",
    fill: "#cc0e2d",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/HomeActive.bff53a5c35d5767fcf8fedaa5b087f96.svg";
export { ForwardRef as ReactComponent };